import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { ToastProvider } from './contexts/ToastContext';
import AuthWrapper from './components/auth/AuthWrapper';
import ErrorBoundary from './components/ui/ErrorBoundary';
import ToastContainer from './components/ui/ToastContainer';
import PermissionDebug from './components/debug/PermissionDebug';
import RedirectToFirstRole from './components/ui/RedirectToFirstRole';
import GamesPage from './pages/GamesPage';
import GameDetailsPage from './pages/GameDetailsPage';
import SettingsPage from './pages/SettingsPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <ToastProvider>
          <AuthWrapper>
            <PermissionProvider>
              <Routes>
                <Route path="/" element={<RedirectToFirstRole />} />
                <Route path="/games" element={<RedirectToFirstRole />} />
                <Route path="/games/:company" element={<GamesPage />} />
                <Route path="/games/:company/:game/:gameType" element={<GameDetailsPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/settings/profile" element={<SettingsPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
              <PermissionDebug />
              <ToastContainer />
            </PermissionProvider>
          </AuthWrapper>
        </ToastProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
